import { render, staticRenderFns } from "./AccountPortfolio.vue?vue&type=template&id=00b469e7&"
import script from "./AccountPortfolio.vue?vue&type=script&lang=js&"
export * from "./AccountPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports